<template>
  <div class="form-container">
    <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
        <div class="page_nav">
          <ul>
            <li>
              <router-link to="/main" @click.native="$store.commit('setActive', '')">{{
                $t("common.home")
              }}</router-link>
            </li>
            <li>
              <router-link to="/support/Notice">{{ $t("common.support") }}</router-link>
            </li>
            <li v-if="this.$route.path.includes('/support/notice')">
              <a href="#">{{ $t("support.support.notice") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/support/qna')">
              <a href="#">{{ $t("support.support.qna") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/support/faq')">
              <a href="#">{{ $t("support.support.faq") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/support/contactus')">
              <a href="#">{{ $t("support.support.contactus") }}</a>
            </li>
          </ul>
        </div>
        <h2>{{ $t("common.support") }}</h2>
      </div>
    </div>
    <section class="sub_contents_wrap">
      <div class="stu_tab">
        <ul class="view_web">
          <li>
            <router-link
              @click.native="[loadComponent('Notice'), changeNav('Notice')]"
              ref="Notice"
              :class="this.$route.path.includes('/support/notice') ? 'on' : ''"
              to="/support/notice"
              >{{ $t("support.support.notice") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('Q&A'), changeNav('Q&A')]"
              ref="Q&A"
              :class="this.$route.path.includes('/support/qna') ? 'on' : ''"
              to="/support/qna"
              >{{ $t("support.support.qna") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('FAQ'), changeNav('FAQ')]"
              ref="FAQ"
              :class="this.$route.path.includes('/support/faq') ? 'on' : ''"
              to="/support/faq"
              >{{ $t("support.support.faq") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('Contact Us'), changeNav('Contact Us')]"
              ref="Contact Us"
              :class="this.$route.path.includes('/support/contactus') ? 'on' : ''"
              to="/support/contactus"
              >{{ $t("support.support.contactus") }}</router-link
            >
          </li>
        </ul>
        <div class="subtab_drop dropdown">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="subTabdropdown01"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ nav }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="subTabdropdown01">
            <li>
              <router-link
                @click.native="[loadComponent('Notice'), changeNav('Notice')]"
                ref="Notice"
                :class="this.$route.path.includes('/support/notice') ? 'on' : ''"
                class="dropdown-item"
                to="/support/notice"
                >{{ $t("support.support.notice") }}</router-link
              >
            </li>
            <li>
              <router-link
                @click.native="[loadComponent('Q&A'), changeNav('Q&A')]"
                ref="Q&A"
                :class="this.$route.path.includes('/support/qna') ? 'on' : ''"
                class="dropdown-item"
                to="/support/qna"
                >{{ $t("support.support.qna") }}</router-link
              >
            </li>
            <li>
              <router-link
                @click.native="[loadComponent('FAQ'), changeNav('FAQ')]"
                ref="FAQ"
                :class="this.$route.path.includes('/support/faq') ? 'on' : ''"
                class="dropdown-item"
                to="/support/faq"
                >{{ $t("support.support.faq") }}</router-link
              >
            </li>
            <li>
              <router-link
                @click.native="[loadComponent('Contact Us'), changeNav('Contact Us')]"
                ref="Contact Us"
                :class="this.$route.path.includes('/support/contactus') ? 'on' : ''"
                class="dropdown-item"
                to="/support/contactus"
                >{{ $t("support.support.contactus") }}</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <router-view></router-view>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      component: null,
      componentName: null,
      on: false,
      boardId: "",
      nav: "Notice",
      param: "",
    };
  },
  methods: {
    loadComponent(type) {
      this.on = true;
      this.componentName = type;
      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setComponentName", type);
      this.boardId = this.$store.getters.getBoardId;
    },
    changeNav(name) {
      this.nav = name;
    },
  },
  mounted() {
    if (
      this.$store.state.componentName == "" ||
      this.$store.state.componentName == "Notice"
    ) {
      this.$store.commit("setComponentName", "Notice");
      this.componentName = "Notice";
      this.loadComponent("Notice");
    } else {
      this.loadComponent(this.$store.state.componentName);
    }
  },
};
</script>

<style></style>
